import { Heart } from "lucide-react";

const RAINBOW_BG =
  "linear-gradient(180deg, #DC2626 0%, #F97316 16%, #FACC15 33%, #22C55E 50%, #3B82F6 66%, #8B5CF6 83%, #EC4899 100%)";

const BADGES = [
  {
    id: "black-owned",
    title: "Black-Owned",
    subtitle: "Certified Identity",
    body: "Roots in Black excellence. Built unapologetically.",
    Mark: () => (
      <div className="flex-shrink-0 w-16 h-16 bg-black border-2 border-[#D4AF37] flex items-center justify-center">
        <span className="font-display text-3xl text-[#D4AF37] leading-none">
          B<span className="text-white">O</span>
        </span>
      </div>
    ),
  },
  {
    id: "lgbtq-owned",
    title: "LGBTQ+ Owned",
    subtitle: "Certified Identity",
    body: "Visibility, strength, and love — every rep.",
    Mark: () => (
      <div
        className="flex-shrink-0 w-16 h-16 flex items-center justify-center text-3xl"
        style={{ background: RAINBOW_BG }}
      >
        <span aria-hidden="true">🌈</span>
      </div>
    ),
  },
  {
    id: "autistic-owned",
    title: "Autistic-Owned",
    subtitle: "Neurodivergent Pride",
    body: "Different wiring, undeniable focus. Autism Level 1, fully owned.",
    Mark: () => (
      <div className="flex-shrink-0 w-16 h-16 bg-black border-2 border-[#D4AF37] flex items-center justify-center relative overflow-hidden">
        <svg viewBox="0 0 64 64" className="w-12 h-12">
          <defs>
            <linearGradient id="ndRainbow" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#DC2626" />
              <stop offset="20%" stopColor="#F97316" />
              <stop offset="40%" stopColor="#FACC15" />
              <stop offset="60%" stopColor="#22C55E" />
              <stop offset="80%" stopColor="#3B82F6" />
              <stop offset="100%" stopColor="#8B5CF6" />
            </linearGradient>
          </defs>
          {/* Infinity loop — neurodiversity symbol */}
          <path
            d="M 16 32 C 16 22, 26 22, 32 32 C 38 42, 48 42, 48 32 C 48 22, 38 22, 32 32 C 26 42, 16 42, 16 32 Z"
            fill="none"
            stroke="url(#ndRainbow)"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    ),
  },
  {
    id: "disabled-owned",
    title: "Disabled-Owned",
    subtitle: "Certified Identity",
    body: "Cerebral Palsy. Still showing up. Still lifting heavy.",
    Mark: () => (
      <div className="flex-shrink-0 w-16 h-16 bg-black border-2 border-[#D4AF37] flex items-center justify-center">
        <span className="font-display text-3xl text-[#D4AF37] leading-none">
          D<span className="text-white">O</span>
        </span>
      </div>
    ),
  },
];

export default function Diversity() {
  return (
    <section
      id="diversity"
      data-testid="diversity-section"
      className="py-16 md:py-20 bg-black border-y border-zinc-900 relative"
    >
      <div
        className="absolute inset-0 opacity-10 pointer-events-none"
        style={{
          background:
            "linear-gradient(90deg, #DC2626 0%, #F97316 16.66%, #FACC15 33.33%, #22C55E 50%, #3B82F6 66.66%, #8B5CF6 83.33%, #EC4899 100%)",
        }}
      />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#D4AF37]/40 text-[#D4AF37] mb-5">
            <Heart size={14} fill="currentColor" />
            <span className="font-accent text-xs tracking-[0.3em] uppercase">
              Proudly Owned · Proudly Open
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl text-white leading-[0.9]">
            Built With <span className="text-[#D4AF37]">Pride.</span>
            <br />
            Built For <span className="text-white">Everyone.</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 max-w-4xl mx-auto">
          {BADGES.map((b) => (
            <article
              key={b.id}
              data-testid={`badge-${b.id}`}
              className="bg-[#0F0F0F] border-2 border-[#D4AF37] p-5 md:p-6 flex items-center gap-5 group hover:bg-[#1A1A1A] transition-colors"
            >
              <b.Mark />
              <div className="min-w-0">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] font-bold mb-1">
                  {b.subtitle}
                </div>
                <div className="font-display text-2xl md:text-3xl text-white leading-tight">
                  {b.title}
                </div>
                <div className="text-xs text-neutral-400 mt-1">{b.body}</div>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center text-sm md:text-base text-neutral-400 mt-10 max-w-2xl mx-auto leading-relaxed">
          OMNIMUSCLE celebrates every body, every brain, every story, every
          chapter. The work is universal — the welcome is unconditional.{" "}
          <span className="text-white">🌈</span>
        </p>
      </div>
    </section>
  );
}
